import React from 'react';
import './Button.css';

export const Button = ({
  variant = 'primary',
  size = 'md',
  type = 'button',
  disabled = false,
  className = '',
  children,
  ...rest
}) => (
  <button
    type={type}
    disabled={disabled}
    className={`ui-btn ui-btn-${variant} ui-btn-${size} ${className}`.trim()}
    {...rest}
  >
    {children}
  </button>
);

export default Button;
